// 默认 页面 加载完成后会主动 发送 pageEnter 配置一些页面需要自定义处理
const NOT_AUTO_TO_LIST = [
  '/article/', // 资讯详情
  '/search', // 搜索
  '/user/', // 收藏页面 个人主页
]

const cusPageEnter = (url: string) => {
  if (!url) {
    return false
  }
  const len = NOT_AUTO_TO_LIST.length
  for (let i = 0; i < len; i++) {
    if (url?.indexOf(NOT_AUTO_TO_LIST[i]) > -1) {
      return true
    }
  }
  return false
}

export default cusPageEnter
